import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

import logo from "../../static/db-logo.png" // Tell Webpack this JS file uses this image


class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const rootPath = `${__PATH_PREFIX__}/`
    let header

    if (location.pathname === rootPath) {
      header = (
        <h1
          style={{
            ...scale(1.2),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
      )
    } else {
      header = (
        <h3
          style={{
            fontFamily: `Montserrat, sans-serif`,
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h3>
      )
    }
    return (
      <div style={{display: 'inline'}}>
      <Link
            style={{
              boxShadow: `none`,
              textDecoration: `none`,
              color: `inherit`,
            }}
            to={`/`}
        >
        <img src={logo} alt="Logo" style={{marginLeft:'20px', marginTop: '20px'}} />
      </Link>
      <div
        style={{
          marginLeft: `auto`,
          marginRight: `auto`,
          marginTop: '-20px',
          maxWidth: rhythm(24),
          padding: `20px`,
        }}
      >
        <header>{header}</header>
        <main>{children}</main>
        <footer>
          © {new Date().getFullYear()}
          {` `}
          <a href="https://www.doctorsbazaar.com">Doctor's Bazaar</a>
        </footer>
      </div>
      </div>
    )
  }
}

export default Layout
